<template>
  <div class="third">
    <div class="third-formOne AutomaticShielding">
      <div class="formOne-btn">
        <div class="btn-left">
          <div>
            <div class="btn-left">
              <span class="left-back-icon" @click="goBack">
                <i class="el-icon-arrow-left"></i>
                <span class="left-back-title">返回</span>
              </span>
              <span class="left-back-shu">
                <span class="left-back-shu-content"></span>
              </span>
              <span class="left-back-content">自动屏蔽策略</span>
            </div>
          </div>
        </div>
        <div class="btn-right">
          <el-button @click="Preservation()" class="btn-two" type="primary">保存</el-button>
          <el-button @click="Reset" class="btn-two" type="default">重置</el-button>
        </div>
      </div>
      <div class="formOne-forms">
        <div class="forms-one" style="padding-top:54px">
          <div class="one-title">
            <div class="title-left">
              <span class="left-icon">
                <i class="el-icon-s-operation"></i>
              </span>
              <span class="left-content">配置</span>
            </div>
          </div>
          <div class="one-list">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="86px">
              <div class="list-one-line">
                <el-form-item label="自动屏蔽策略" prop="id">
                  <el-radio-group v-model="ruleForm.id" style="display: block;margin-top: 7px;">
                    <el-radio style="margin-left:10px;display: block;" :label="1">无</el-radio>
                    <el-radio style="margin-top:10px;margin-left:10px" :label="2">
                      举报
                      <el-input-number
                        v-model="ruleForm.number"
                        controls-position="right"
                        :min="1"
                        step-strictly
                        :controls="false"
                        style="width:100px"
                      ></el-input-number>
                      <span style="color:black;">次自动屏蔽动态</span>
                    </el-radio>
                  </el-radio-group>
                  <span style="margin-left: 10px;color:red;font-size:12px">每次举报都会提醒违规用户</span>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAutoShieldConfigList,
  updateAutoShieldConfig
} from "@/store/mymethod/ShieldingManagement"; //我的

export default {
  name: "formSeven",
  data() {
    return {
      ruleForm: {
        number: 1, //多少次屏蔽
        id: "", //单选
        isUse: 1 //是否为当前策略  1选择为当前策略 默认为1
      },
      rules: {
        id: [{ required: true, message: "请输入", trigger: "blur" }]
      },
      id: "", //保存的初始数据
      number: "" //保存的初始数据
    };
  },
  created() {},
  mounted() {
    this.getAutoShieldConfigList();
  },
  methods: {
    //返回
    goBack() {
      this.$emit("backHome", false);
    },
    //获取初始数据
    getAutoShieldConfigList() {
      try {
        getAutoShieldConfigList().then(res => {
          const data = res.data;
          console.log("获取初始数据", data);
          if (data.status === 1000) {
            let listdata = data.result;
            listdata.forEach(item => {
              if (item.isUse == 1) {
                console.log("我需要的", item);
                this.ruleForm.id = item.id;
                this.id = item.id;
                this.ruleForm.number = item.number;
                this.number = item.number;
              }
            });
          }else{
            this.$message.error(data.msg)
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //保存
    Preservation() {
      console.log("保存", this.ruleForm);
      try {
        const params = this.ruleForm;
        updateAutoShieldConfig(params).then(res => {
          const data = res.data;
          if (data.status === 1000) {
            this.goBack();
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          }else{
            this.$message.error(data.msg)
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //重置
    Reset() {
      this.ruleForm.id = this.id;
      this.ruleForm.number = this.number;
    },
    //----------------------------------------------

    //表单验证
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //表单重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style lang="scss">
.AutomaticShielding {
  .el-input {
    width: 100%;
  }
}
</style>
